// removed by extract-text-webpack-plugin
module.exports = {"recorderHtml":"src-components-Common-Recorder-index-recorderHtml-2KYMj","bottomBtn":"src-components-Common-Recorder-index-bottomBtn-3q57s","startBtn":"src-components-Common-Recorder-index-startBtn-1dDmD","reprtRecord":"src-components-Common-Recorder-index-reprtRecord-2b-GF","stopBtn":"src-components-Common-Recorder-index-stopBtn-2YNlJ","squareBtn":"src-components-Common-Recorder-index-squareBtn-1T4nb","soundWave":"src-components-Common-Recorder-index-soundWave-D9X1F","restartRecord":"src-components-Common-Recorder-index-restartRecord-s2_7w"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Recorder/index.css
 ** module id = 264
 ** module chunks = 0
 **/